import { render, staticRenderFns } from "./newon.vue?vue&type=template&id=2d4d1f0a"
import script from "./newon.vue?vue&type=script&lang=js"
export * from "./newon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports